import * as Yup from 'yup';
export default Yup.object().shape({
    firstName: Yup.string().required("This field is required."),
    lastName: Yup.string().required("This field is required."),
    acceptMarketingEmail: Yup.bool()
});